const withReentry = (store, defaultModuleName) => {
  const reentryData = store
    .getState()
    .getIn(['modules', 'axp-reentry-journey', 'reentryApplicantData']);
  if (!reentryData || (reentryData.isEmpty && reentryData.isEmpty())) {
    return 'axp-reentry-journey';
  }
  return defaultModuleName;
};

export default withReentry;
